import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthContext, AuthProvider } from './context/AuthContext';
import Login from './components/Auth/Login';
import ForceChangePassword from './components/Auth/ForceChangePassword';
import ForgotPassword from './components/Auth/ForgotPassword';
import AppLayout from './components/Layout/AppLayout';

const PrivateRoute = ({ children }) => {
  const { authToken, isInitializing } = useContext(AuthContext);
  if (isInitializing) {
    return null;
  }
  return authToken ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/force-change-password" element={<ForceChangePassword />} />
          <Route path="/auth/forgot-password" element={<ForgotPassword />} />
          <Route path="/*" element={<PrivateRoute><AppLayout /></PrivateRoute>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
